module.exports = __webpack_public_path__ + "static/img/file_video.5dbeb486.png";